(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kalk-mobile-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kalk-mobile-share')) {
    customElements.define('kalk-mobile-share', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.trigger = this.querySelector('[data-ks-trigger]');
        this.dialog = this.querySelector('[data-ks-dialog]');
        this.input = this.querySelector('[data-ks-url]');
        this.status = this.querySelector('[data-ks-status]');
        if (!this.trigger || !this.dialog || !this.input) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger.addEventListener('click', event => { event.stopPropagation(); this.share(); }, options);
        this.querySelector('[data-ks-close]').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('[data-ks-copy]').addEventListener('click', () => this.copy(), options);
        this.dialog.addEventListener('close', () => { if (this.isConnected) this.trigger.focus(); }, options);
        this.dialog.addEventListener('click', event => {
          event.stopPropagation();
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
      }
      getShareData() {
        // Compartir el producto público, sin parámetros del tema de prueba ni seguimiento.
        const url = new URL(this.dataset.url, window.location.origin);
        url.search = '';
        url.hash = '';
        return { title: this.dataset.title || document.title, url: url.href };
      }
      async share() {
        if (this.busy) return;
        const data = this.getShareData();
        if (typeof navigator.share === 'function') {
          this.busy = true;
          try {
            await navigator.share(data);
            return;
          } catch (error) {
            if (error?.name === 'AbortError') return;
          } finally {
            this.busy = false;
          }
        }
        if (this.isConnected) this.openFallback(data);
      }
      openFallback(data) {
        this.input.value = data.url;
        this.status.textContent = '';
        this.querySelector('[data-ks-whatsapp]').href = 'https://wa.me/?text=' + encodeURIComponent(data.title + '\n' + data.url);
        this.querySelector('[data-ks-facebook]').href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(data.url);
        this.querySelector('[data-ks-email]').href = 'mailto:?subject=' + encodeURIComponent(data.title) + '&body=' + encodeURIComponent(data.url);
        if (!this.dialog.open) this.dialog.showModal();
      }
      async copy() {
        const value = this.input.value;
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(value);
          this.status.textContent = 'Enlace copiado';
        } catch (_) {
          this.input.focus();
          this.input.select();
          this.input.setSelectionRange(0, value.length);
          this.status.textContent = 'Mantén pulsado el enlace seleccionado para copiarlo.';
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
